export default {
  attachments: 'Attachment (optional)',
  attachmentButton: 'Choose',
  attachmentLabel: 'Maximum {{fileSize}} MB per file ({{filesAuthorized}})',
};
